import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';

import { getDurationStringFromSeconds, getDateTimeString, UserDetailsRow } from '@/exceed';

import styles from '../styles/videosAdminViewDataRow.module.scss';

/* eslint-disable camelcase */
const VideosAdminViewDataRow = ({
  item: {
    user_position, user_code, avatar_url, name, started_at, duration, version,
  },
}) => {
  const startedAt = getDateTimeString(started_at);

  return (
    <div className={styles.element}>
      <UserDetailsRow
        className={classnames(styles.column, styles.isGrower)}
        name={name}
        position={user_position}
        code={user_code}
        avatarUrl={avatar_url}
      />
      <Typo variant="s02" className={classnames(styles.column, styles.isWideFixed)}>{startedAt}</Typo>
      <Typo variant="s02" className={classnames(styles.column, styles.isFixed)}>
        {getDurationStringFromSeconds(duration)}
      </Typo>
      <Typo variant="s02" className={classnames(styles.column, styles.isFixed)}>{version}</Typo>
      <div className={styles.columnEnd} />
    </div>
  );
};

VideosAdminViewDataRow.propTypes = {
  item: PropTypes.shape({}).isRequired,
};

export default React.memo(VideosAdminViewDataRow);
